import gql from "@/api/gql.js"
import { query, mutation } from "./queries.js"
import resolveApiErrors from "@/api/resolveApiErrors"

export default {
	async createProduct(variables) {
		const res = await gql({
			query: mutation.createProduct,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithoutStatus",
			res,
			resKey: "createProduct"
		})
	},

	async localizeProduct(variables) {
		const res = await gql({
			query: mutation.localizeProduct,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "upsertL10n"
		})
	},

	async readAllProducts(variables, locale) {
		const res = await gql({
			locale,
			query: query.readAllProducts,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "products_2"
		})
	},

	async getProductBenefits(variables, locale) {
		const res = await gql({
			locale,
			query: query.getProductBenefits,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "product"
		})
	},

	async addBenefit(variables) {
		const res = await gql({
			query: mutation.addBenefit,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "addBenefit"
		})
	},

	async removeBenefit(variables) {
		const res = await gql({
			query: mutation.removeBenefit,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "removeBenefit"
		})
	},

	async getProductPricingAndUnderwriting(variables) {
		const res = await gql({
			query: query.getProductPricingAndUnderwriting,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "products_2"
		})
	},

	async updatePriceLogic(variables) {
		const res = await gql({
			query: mutation.updatePriceLogic,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "updatePriceLogic"
		})
	},

	async createPriceLogic(variables) {
		const res = await gql({
			query: mutation.createPriceLogic,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "updatePriceLogic"
		})
	},

	async updateProductUnderwriting(variables) {
		const res = await gql({
			query: mutation.updateProductUnderwriting,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "updatePriceLogic"
		})
	},

	async deleteProduct(variables) {
		const res = await gql({
			query: mutation.deleteProduct,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "deleteProduct"
		})
	},

	async deleteAllL10n(variables) {
		const res = await gql({
			query: mutation.deleteAllL10n,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "deleteAllL10n"
		})
	}
}
